module.exports = __webpack_public_path__ + "static/media/thinkTankLogo.4b769da4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thinkTankLogo.svg
// module id = 1280
// module chunks = 0